import React from 'react';

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  return (
    <div className="bg-background border-border hover:border-muted-foreground/30 rounded-sm border p-6 transition-colors">
      <div className="text-muted-foreground bg-muted mb-4 flex h-10 w-10 items-center justify-center rounded-sm">
        {icon}
      </div>
      <h3 className="text-foreground mb-2 text-lg font-medium">{title}</h3>
      <p className="text-muted-foreground text-sm leading-relaxed">{description}</p>
    </div>
  );
};

export default FeatureCard;
